export default {
    productName: '$t("header.d")',
    productImg: require('../../../assets/image/astp/4.jpg'),

    insuranceName: '$t("labels.l")',
    insuranceDownloadName: '安盛天平境外旅行保险签证款保险条款.pdf',
    insuranceFile: 'https://image.ssish.com/static/product/axatp002/file/axatp002_TK.pdf',

    claimGuideName: '$t("labels.h")',
    claimGuideDownloadName: '索赔申请书填写示例.pdf',
    claimGuideFile: 'https://cps.ssish.com/axa/files/索赔申请书填写示例.pdf',

    claimFormName: '',
    claimFormDownloadName: '',
    claimFormFile: 'https://cps.ssish.com/axa/files/索赔申请书下载.pdf',

    destination: '$t("addPolicy.v")',
    disabledDest: true,

    lpShow: true, // 详情页理赔指引理赔部门模块是否显示
    ageRange: '$t("labels.b")',
    showInvoiceModal: true,
    showHowPolicy: true,
    underCompanyName: "安盛天平财产保险有限公司"
}